var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-content"},[(_vm.loading)?_c('div',{staticClass:"my-10 d-flex justify-center"},[_c('v-progress-circular',{attrs:{"indeterminate":""}})],1):_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }